var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable max-lines */
import React from 'react';
import { createRoutesFromElements, Route } from 'react-router-dom';

import { App } from "./App/App";
import Activitylog from "./Activitylog/Activitylog";
import Configure2fa from "./Auth2fa/Configure2fa";
import { LibraryCards } from "./Library/Library";
import { LibraryMap } from "./Library/LibraryMap";
import { EditPage } from "./Pages/EditPage";
import NewPage from "./Pages/NewPage";
import Pages from "./Pages/Pages";
import { EditRelationType } from "./RelationTypes/EditRelationType";
import NewRelationType from "./RelationTypes/NewRelationType";
import {
  PreserveSettings,
  CollectionSettings,
  Customisation,
  CustomUploads,
  EntityTypesList,
  FiltersForm,
  NavlinksSettings,
  RelationTypesList,
  Settings,
  ThesauriList,
  Dashboard } from "./Settings";

import { EditTemplate } from "./Templates/EditTemplate";
import NewTemplate from "./Templates/NewTemplate";
import { EditThesauri } from "./Thesauri/EditThesauri";
import NewThesauri from "./Thesauri/NewThesauri";
import ThesaurusCockpit from "./Thesauri/ThesaurusCockpit";
import { Login } from "./Users/Login";
import GeneralError from "./App/ErrorHandling/GeneralError";
import { Users, usersLoader, userAction } from "./V2/Routes/Settings/Users/Users";
import { LibraryTable } from "./Library/LibraryTable";
import ViewerRoute from "./Viewer/ViewerRoute";

import {
  TranslationsList,
  translationsListLoader } from "./V2/Routes/Settings/Translations/TranslationsList";

import {
  EditTranslations,
  editTranslationsLoader,
  editTranslationsAction } from "./V2/Routes/Settings/Translations/EditTranslations";

import { LanguagesList, languagesListLoader } from "./V2/Routes/Settings/Languages/LanguagesList";
import { Account, accountLoader } from "./V2/Routes/Settings/Account/Account";
import { dashboardLoader, IXDashboard } from "./V2/Routes/Settings/IX/IXDashboard";
import { loggedInUsersRoute, adminsOnlyRoute, privateRoute } from "./ProtectedRoute";
import { getIndexElement } from "./getIndexElement";
import { PageView } from "./Pages/PageView";
import { RouteErrorBoundary } from "./App/ErrorHandling/RouteErrorBoundary";
import ResetPassword from "./Users/ResetPassword";
import ConnectedUnlockAccount from "./Users/UnlockAccount";
import { IXSuggestions, IXSuggestionsLoader } from "./MetadataExtraction/SuggestionsContainer";
import OneUpReview from "./Review/OneUpReview";
import { NewRelMigrationDashboard } from "./Settings/components/relV2MigrationDashboard";

const getRoutesLayout = (
settings,
indexElement,
headers) => {var _settings$features;return /*#__PURE__*/(

    _jsx(Route, { errorElement: /*#__PURE__*/_jsx(RouteErrorBoundary, {}) }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: indexElement }), /*#__PURE__*/
    _jsx(Route, { path: "login", element: /*#__PURE__*/_jsx(Login, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "library", element: privateRoute( /*#__PURE__*/_jsx(LibraryCards, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "library/map", element: privateRoute( /*#__PURE__*/_jsx(LibraryMap, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "library/table", element: privateRoute( /*#__PURE__*/_jsx(LibraryTable, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "document/:sharedId/*", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId/*", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId/:tabView", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "error/:errorCode", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "404", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId/:slug", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "setpassword/:key", element: /*#__PURE__*/_jsx(ResetPassword, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "unlockaccount/:username/:code", element: /*#__PURE__*/_jsx(ConnectedUnlockAccount, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "review", element: adminsOnlyRoute( /*#__PURE__*/_jsx(OneUpReview, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "settings", element: loggedInUsersRoute( /*#__PURE__*/_jsx(Settings, {})) }, void 0, /*#__PURE__*/
    _jsx(Route, { path: "account", element: /*#__PURE__*/_jsx(Account, {}), loader: accountLoader(headers) }), /*#__PURE__*/
    _jsx(Route, { path: "dashboard", element: adminsOnlyRoute( /*#__PURE__*/_jsx(Dashboard, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "2fa", element: loggedInUsersRoute( /*#__PURE__*/_jsx(Configure2fa, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "collection", element: adminsOnlyRoute( /*#__PURE__*/_jsx(CollectionSettings, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "navlinks", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NavlinksSettings, {})) }), /*#__PURE__*/
    _jsx(Route, {
      path: "users",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(Users, {})),
      loader: usersLoader(headers),
      action: userAction() }
    ), /*#__PURE__*/
    _jsx(Route, { path: "preserve", element: adminsOnlyRoute( /*#__PURE__*/_jsx(PreserveSettings, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "pages" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(Pages, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NewPage, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:sharedId", element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditPage, {})) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "templates" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(EntityTypesList, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NewTemplate, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:templateId", element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditTemplate, {})) })
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "metadata_extraction",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(IXDashboard, {})),
      loader: dashboardLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "metadata_extraction/suggestions/:extractorId",
      loader: IXSuggestionsLoader(headers),
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(IXSuggestions, {})) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "connections" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(RelationTypesList, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NewRelationType, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:_id", element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditRelationType, {})) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "dictionaries" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(ThesauriList, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NewThesauri, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:_id", element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditThesauri, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "cockpit/:_id", element: adminsOnlyRoute( /*#__PURE__*/_jsx(ThesaurusCockpit, {})) })
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "languages",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(LanguagesList, {})),
      loader: languagesListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "translations" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(TranslationsList, {})),
      loader: translationsListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "edit/:context",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditTranslations, {})),
      loader: editTranslationsLoader(headers),
      action: editTranslationsAction() }
    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "filters", element: adminsOnlyRoute( /*#__PURE__*/_jsx(FiltersForm, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "customisation", element: adminsOnlyRoute( /*#__PURE__*/_jsx(Customisation, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "custom-uploads", element: adminsOnlyRoute( /*#__PURE__*/_jsx(CustomUploads, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "activitylog", element: adminsOnlyRoute( /*#__PURE__*/_jsx(Activitylog, {})) }), /*#__PURE__*/
    _jsx(Route, {
      path: "newrelmigration",
      element:
      settings !== null && settings !== void 0 && (_settings$features = settings.features) !== null && _settings$features !== void 0 && _settings$features.newRelationships ? /*#__PURE__*/_jsx(NewRelMigrationDashboard, {}) : /*#__PURE__*/_jsx(GeneralError, {}) }

    )
    )
    ));};


const getRoutes = (
settings,
userId,
headers) =>
{
  const { element, parameters } = getIndexElement(settings, userId);
  const layout = getRoutesLayout(settings, element, headers);
  return createRoutesFromElements( /*#__PURE__*/
    _jsx(Route, { path: "/", element: /*#__PURE__*/_jsx(App, { customParams: parameters }) }, void 0,
    layout, /*#__PURE__*/
    _jsx(Route, { path: ":lang" }, void 0,
    layout, /*#__PURE__*/
    _jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
    )
  );
};

export { getRoutes };